import React from 'react';
import courseDescriptionStyle from './style';

export default function CourseDescription({title, texts, addonStyle, mt}) {
	let style = courseDescriptionStyle();
	return (
		<div
			style={{
				...style.outerStyle({mt: mt}),
				...addonStyle,
			}}
		>
			<h1 style={style.titleText()}>{title}</h1>
			{texts.map((text, i) => {
				return (
					<p style={style.genericText()} key={i}>
						{text}
					</p>
				);
			})}
		</div>
	);
}
